import React from "react";
import "./Footer.css";

/**
 * @typedef {Object} FooterProps
 * @property {number} [year] - Copyright year; defaults to current year
 * @property {{ facebook?: string; instagram?: string; youtube?: string }} [socialLinks]
 * @property {string} [className]
 * @property {string} [logoSrc] - Logo image path; defaults to /img/logo_black.png
 */

/**
 * @param {FooterProps} props
 */
const Footer = ({
  year = new Date().getFullYear(),
  socialLinks,
  className = "",
  logoSrc = "/img/logo_black.png",
}) => {
  const facebookUrl = socialLinks?.facebook ?? "#";
  const instagramUrl = socialLinks?.instagram ?? "#";

  return (
    <footer
      className={`footer ${className}`.trim()}
      aria-label="Site footer"
    >
      <div className="footer-divider" />

      <div className="footer-inner">
        <div className="footer-logo">
          <img src={logoSrc} alt="The Yacht Party" />
        </div>

        <p className="footer-copy">Copyright © {year} Casheers</p>

        <div className="footer-social">
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="footer-social-icon"
          >
            <i className="fa fa-facebook" aria-hidden="true" />
          </a>
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="footer-social-icon"
          >
            <i className="fa fa-instagram" aria-hidden="true" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
